import React from 'react';
import {connect} from 'react-redux';
import Reports, {DisplayMode} from "../../components/report/Reports/Reports";
import {setOxMode} from "../../store/ui/actions";

export class ReportsMapPage extends React.Component {

    componentWillMount() {
        this.props.setOxMode(DisplayMode.MODE_MAP);
    }

    render() {
        return <Reports
            mode={DisplayMode.MODE_MAP}
            match={this.props.match}
        />
    }
}

function mapStateToProps(state, ownProps) {
    return {}
}

export default connect(mapStateToProps, {
    setOxMode
})(ReportsMapPage);



// WEBPACK FOOTER //
// src/containers/reports/ReportsMapPage.js